var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from "styled-components";
import Icon from './IconBase';
var centerPath = {
    timer: 'M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z',
    help: 'M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0130.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1080 0 40 40 0 10-80 0z',
};
function TimerIcon(_a) {
    var _b = _a.center, center = _b === void 0 ? 'timer' : _b, width = _a.width, height = _a.height, props = __rest(_a, ["center", "width", "height"]);
    var size = width || height || 16;
    function renderCenter() {
        switch (center) {
            case 'none':
                return null;
            default:
                return React.createElement("path", { d: centerPath[center] });
        }
    }
    return (React.createElement(Icon, __assign({ "data-icon": 'TimerIcon', viewBox: "64 64 896 896", width: size, height: size }, props),
        React.createElement("path", { d: "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" }),
        renderCenter()));
}
export default styled(TimerIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var CircleIcon = styled(TimerIcon).attrs(function () { return ({ center: 'none' }); })(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var HelpIcon = styled(TimerIcon).attrs(function () { return ({ center: 'help' }); })(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
export { CircleIcon, HelpIcon };
var templateObject_1, templateObject_2, templateObject_3;
